import * as Yup from 'yup';
import React from "react";
import {CaseStepperType, CaseSubTypes} from "../../../helpers/enums";
import {TranslatedText, getComuniServiti} from "../../../helpers/helpers";
import {removeRequiredStep, removeDeletedLayoutFields} from '../../../helpers/helpers'
// import DigitalizzazioneDocument from "../custom-steps/custom-digitalizzazione-step/DigitalizzazioneDocument";

// Il model definisce la struttura dei dati
// formId è un identificatore del form
// formField contiene la definizione dei singoli campi

let model = {
  formId: 'testCase',
  formField: {
    tipologia: {
      name: "tipologia",
      label: <TranslatedText i18nKey="cases.allacciamento.tipologia.label"/>,
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.tipologia.placeholder"/>
      ),
      requiredErrorMsg: <TranslatedText i18nKey="common.select"/>,
      type: "select",
      textSummaryWithKeyPrefix:  'cases.enums.CaseSubTypes.',
      options: [
        {
          label: <TranslatedText i18nKey={"cases.enums.CaseSubTypes.WATER"}/>,
          value: CaseSubTypes.WATER,
        },
        {
          label: (
            <TranslatedText i18nKey={"cases.enums.CaseSubTypes.WATER_EXT"}/>
          ),
          value: CaseSubTypes.WATER_EXT,
        },
      ],
    },
    fisicaIndirizzoResidenza: {
      name: 'fisicaIndirizzoResidenza',
      label: <TranslatedText i18nKey="cases.request_info.fields.indirizzoResidenza.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      type: 'google-address',
      suggestionType: 'address',
      onSelect: (components, setFieldValue) => {
        setFieldValue(fisicaIndirizzoResidenza.name, `${components.via}, ${components.civico || ''}`);
        setFieldValue(fisicaComuneResidenza.name, components.comune || '');
        setFieldValue(fisicaCAP.name, components.cap || '');
        setFieldValue(fisicaProvincia.name, components.provincia || '');
      },
    },
    idType: {
      name: 'idType',
      label: <TranslatedText i18nKey="cases.digitalization.idType.placeholder" />,
      placeholder: <TranslatedText i18nKey="cases.richiedi_omaggio.idType.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey='cases.errors.required' />,
      type: 'select',
      options: [
        {
          label:'',
          value:''
        },
        {
          label: <TranslatedText i18nKey="ID" />,
          value: 'ID'
        },
        {
          label:  <TranslatedText i18nKey="Passport" />,
          value: 'Passport'
        },
        {
          label:  <TranslatedText i18nKey="Driving_licence" />,
          value: 'Driving_licence'
        },
      ]
    },
    fisicaComuneResidenza: {
      name: 'fisicaComuneResidenza',
      label: <TranslatedText i18nKey="cases.request_info.fields.comuneResidenza.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input'
    },
    fisicaProvincia: {
      name: 'fisicaProvincia',
      label: <TranslatedText i18nKey="cases.request_info.fields.provincia.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required'/>,
      type: 'input',
    },
    fisicaCAP: {
      name: 'fisicaCAP',
      label: <TranslatedText i18nKey="cases.request_info.fields.fisicaCap.label"/>,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      invalidErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.cap.invalid'/>,
      type: 'input'
    },

    campo_input: {
      name: 'campo_input',
      label: 'Campo Input*',
      placeholder: 'Inserisci',
      requiredErrorMsg: 'È richiesto',
      type: 'input',
    },
    campo_date: {
      name: 'campo_date',
      label: <TranslatedText i18nKey="fieldsInterfaces.date.label"/>,
      placeholder: <TranslatedText i18nKey="fieldsInterfaces.date.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="fieldsInterfaces.date.required"/>,
      type: 'date',
      onDateChanged: (date, values, setFieldValue) => {
        console.log('Date selected: ', date);
      },
    },
    campo_contract: {
      name: 'campo_contract',
      label: <TranslatedText i18nKey="fieldsInterfaces.contract-select.label"/>,
      placeholder: <TranslatedText i18nKey="fieldsInterfaces.contract-select.select-contract"/>,
      loading: <TranslatedText i18nKey="fieldsInterfaces.contract-select.loading"/>,
      noContractFound: <TranslatedText i18nKey="fieldsInterfaces.contract-select.no-contract-found"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required"/>,
      type: 'active-contract-select',
      excludeStatusTypes: ['inactive'],
      onSelected: (selected, values, setFieldValue) => {
        console.log('selected contract: ', selected);
        setFieldValue('campo_input', selected.id);
      },
    },
    campo_select: {
      name: 'campo_select',
      label: 'Campo Select*',
      placeholder: 'Inserisci',
      requiredErrorMsg: 'È richiesto',
      type: 'select',
      options: [
        {label: 'Opzione 1', value: 'OPTION1'},
        {label: 'Opzione 2', value: 'OPTION2'},
        {label: 'Opzione 3', value: 'OPTION3'},
      ]
    },
    campo_radio: {
      name: 'campo_radio',
      label: 'Campo Radio*',
      placeholder: 'Inserisci',
      requiredErrorMsg: 'È richiesto',
      type: 'radio',
      summaryLabel: "Hello",
      summaryView: false,
      options: [
        {
          label: <TranslatedText i18nKey="cases.voltura.promotions.acconsento.label"/>,
          value: "true",
          grid: {xs: 6, md: 3}
        },
        {
          label: <TranslatedText i18nKey="cases.voltura.promotions.non_acconsento.label"/>,
          value: "false",
          grid: {xs: 6, md: 3}
        },
      ]
    },
    campo_radio2: {
      name: 'campo_radio2',
      label: 'Campo Radio*',
      placeholder: 'Inserisci',
      requiredErrorMsg: 'È richiesto',
      type: 'radio',
      summaryLabel: "Hello",
      options: [
        {
          label: <TranslatedText i18nKey="cases.voltura.promotions.acconsento.label"/>,
          value: "true",
          grid: {xs: 6, md: 3}
        },
        {
          label: <TranslatedText i18nKey="cases.voltura.promotions.non_acconsento.label"/>,
          value: "false",
          grid: {xs: 6, md: 3}
        },
      ]
    },

    campo_comune: {
      name: 'campo_comune',
      label: <TranslatedText i18nKey="fieldsInterfaces.city-select.label"/>,
      placeholder: <TranslatedText i18nKey="fieldsInterfaces.city-select.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="fieldsInterfaces.city-select.required"/>,
      type: 'suggestions',
      message: true,
      getItems: (setData) => {
        return getComuniServiti()
          .then(items => setData(items))
          .catch(error => {
            console.log('Error fetching comuni serviti: ', error);
            setData([]);
          })
      },
      getSuggestions: (data) => {
        return data;
      },
      filter: (value, data) => {
        return data.filter(item => {
          return String(item.comune).toLowerCase().indexOf(String(value).toLowerCase()) > -1;
        })
      },
      onSelected: (value, data, setFieldValue) => {
        const [selected] = data.filter(item => String(item.comune).toLowerCase() === String(value).toLowerCase());
        if (selected) {
          setFieldValue('campo_provincia', selected.provincia);
          setFieldValue('campo_cap', selected.cap);
        }
      },
      onBlur: (value, data, setValue) => {
        const [selected] = data.filter(item => String(item.comune).toLowerCase() === String(value).toLowerCase());
        selected ? setValue(selected.comune) : setValue('');
      }
    },
    campo_provincia: {
      name: 'campo_provincia',
      label: <TranslatedText i18nKey="fieldsInterfaces.province-select.label"/>,
      placeholder: <TranslatedText i18nKey="fieldsInterfaces.province-select.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="fieldsInterfaces.province-select.required"/>,
      type: 'input',
      readonly: true,
    },
    campo_cap: {
      name: 'campo_cap',
      label: <TranslatedText i18nKey="fieldsInterfaces.select.label"/>,
      placeholder: <TranslatedText i18nKey="fieldsInterfaces.select.placeholder"/>,
      requiredErrorMsg: <TranslatedText i18nKey="fieldsInterfaces.select.required"/>,
      type: 'input',
      readonly: true,
    },

    campo_checkbox: {
      name: 'campo_checkbox',
      label: 'Campo Checkbox*',
      placeholder: 'Inserisci',
      requiredErrorMsg: 'È richiesto',
      type: 'checkbox',
    },
    campo_checkbox2: {
      name: 'campo_checkbox2',
      label: <TranslatedText i18nKey="cases.voltura.bolletta_online_attiva.label"/>,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required"/>,
      type: 'checkbox',
    },
    campo_text: {
      name: 'campo_text',
      label: 'Campo Text*',
      placeholder: 'Inserisci',
      requiredErrorMsg: 'È richiesto',
      type: 'text',
    },
    campo_stateSelect: {
      name: 'campo_stateSelect',
      label: 'Campo StateSelect* (logged user only)',
      placeholder: 'Inserisci',
      requiredErrorMsg: 'È richiesto',
      type: 'stateSelect',
      statePath: 'contracts',
      stateMappingFunction: (state) => {
        return state.list.map(item => {
          return {value: item.name, label: item.id}
        })
      },
    },
    campo_datepicker: {
      name: 'campo_datepicker',
      label: 'Campo Datepicker*',
      placeholder: 'Inserisci',
      requiredErrorMsg: 'È richiesto',
      type: 'datepicker',
    },
    campo_recaptcha: {
      name: 'campo_recaptcha',
      label: 'Campo Recaptcha*',
      placeholder: 'Inserisci',
      requiredErrorMsg: 'È richiesto',
      type: 'captcha',
    },
    campo_google_address: {
      name: 'campo_google_address',
      label: 'Campo Google Address*',
      placeholder: <TranslatedText i18nKey="common.generic.placeholder"/>,
      requiredErrorMsg: 'È richiesto',
      type: 'google-address',
    },

    fileUpload: {
      name: 'fileUpload',
      label: <TranslatedText i18nKey="cases.request_info.fields.file.label"/>,
      invalidErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.file.not_supported'/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.file.required'/>,
      type: 's3File',
      customPathS3: 'analisi/',//this set for analisi acqua
      // prefixFileName: 'analisi-acqua', //if is not present, take a file prefixFileNameFromInternalField
      prefixFileNameFromInternalFiledName: 'idType',
      allowedExtensions: ['application/pdf', 'image/jpeg'],
      allowDragAndDrop: false
    },
    signDigital: {
      name: 'campo_input',
      label: 'Campo Input*',
      placeholder: 'Inserisci',
      requiredErrorMsg: 'È richiesto',
      type: 'input',
    },
    bank: {
      name: 'bank',
      label: 'bank',
      invalidErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.file.not_supported'/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.file.required'/>,
      type: 'input',
      disabled: true
    },
    agency: {
      name: 'agency',
      label: 'Agency',
      invalidErrorMsg: 'Non abbiamo trovato i tuoi dati inseriscili manualmente',
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.file.required'/>,
      type: 'input',
      disabled: true
    },
    iban: {
      name: 'iban',
      label: 'Iban',
      labelButton: 'Cerca',
      invalidErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.file.not_supported'/>,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.file.required'/>,
      relatedInfo: [
        {'bankName': 'bank'},
        {'agency': 'agency'}
      ],
      type: 'iban',
    }
  }
};

const {
  formField: {
    tipologia,
    signDigital,
    fileUpload,
    idType,
    fisicaComuneResidenza,
    fisicaProvincia,
    fisicaCAP,
    fisicaIndirizzoResidenza,
    iban,
    agency,
    bank,
    campo_input,
    campo_date,
    campo_contract,
    campo_select,
    campo_radio,
    campo_radio2,

    campo_comune,
    campo_provincia,
    campo_cap,

    campo_checkbox,
    campo_checkbox2,
    campo_text,
    campo_stateSelect,

    campo_datepicker,
    campo_recaptcha,
    campo_google_address,
  }
} = model;

// initialValues contiene i valori iniziali del form, ne imposta anche i campi.
// Si può usare per popolare il form eventualmente.
const initialValues = {
  [tipologia.name]: CaseSubTypes.WATER,
  [iban.name]: '',
  [agency.name]: '',
  [bank.name]: '',
  [signDigital.name]: false,
  [fileUpload.name]: '',
  [idType.name]: '',
  [fisicaComuneResidenza.name]: '',
  [fisicaProvincia.name]: '',
  [fisicaCAP.name]: '',
  [fisicaIndirizzoResidenza.name]: '',

  [campo_input.name]: '',
  [campo_date.name]: '',
  [campo_contract.name]: '',
  [campo_select.name]: '',
  [campo_radio.name]: '',
  [campo_radio2.name]: '',

  [campo_comune.name]: '',
  [campo_provincia.name]: '',
  [campo_cap.name]: '',

  [campo_checkbox.name]: false,
  [campo_checkbox2.name]: false,
  [campo_text.name]: '',
  [campo_stateSelect.name]: '',

  [campo_datepicker.name]: '',
  [campo_recaptcha.name]: '',
  [campo_google_address.name]: '',
};

// Per definire il validationSchema si usa un array di shape che indicano gli step.
// L'ordine degli step deve corrispondere a quello in layout.
const getValidationSchema = () => {
  return [
    Yup.object().shape({
      // fisicaIndirizzoResidenza: Yup.string().required(fisicaIndirizzoResidenza.requiredErrorMsg),
      // campo_comune: Yup.string().required(fisicaIndirizzoResidenza.requiredErrorMsg),
      // campo_provincia: Yup.string().required(fisicaIndirizzoResidenza.requiredErrorMsg),
      // campo_cap: Yup.string().required(fisicaIndirizzoResidenza.requiredErrorMsg),
    }),
    // Yup.object().shape({
    //   [fileUpload.name]: Yup.mixed()
    //     .test("fileSize", <TranslatedText
    //       i18nKey="cases.errors.required"/>, (value) => value && value !== undefined).required(<TranslatedText
    //       i18nKey="cases.errors.required"/>),
    // }),
    Yup.object().shape({
      // [campo_recaptcha.name]: Yup.string().required(campo_recaptcha.requiredErrorMsg),
    }),
  ];
}

// Il layout contiene informazioni di testo e di distribuzione sulle griglie
const layout = [
  {
    chapter: true,
    chapterName: 'Form Chapter 1',
    title: 'Primo step',
    beforeSubmit: async (values, actions) => {
      await new Promise((resolve, reject) => {
        const {setErrors} = actions;
        if (values.campo_input !== 'prova') {
          resolve();
        } else {
          setErrors({campo_input: 'non va bene'});
          reject();
        }
        console.log('beforeSubmit ---> ', values, actions);
      });
    },
    fields: [
      {
        fieldName: iban.name,
        grid: {
          xs: 12,
          md: 12,
        },
      },
      {
        fieldName: agency.name,
        grid: {
          xs: 6,
          md: 6,
        },
      },
      {
        fieldName: bank.name,
        grid: {
          xs: 6,
          md: 6,
        },
      },
      {
        fieldName: tipologia.name,
        grid: {
          xs: 6,
          md: 6,
        },
      },
      //   {
      //     fieldName: 'fisicaIndirizzoResidenza',
      //     grid: {
      //       xs: 12,
      //       md: 6,
      //     },
      //   },
      //   {
      //     fieldName: 'fisicaComuneResidenza',
      //     grid: {
      //       xs: 12,
      //       md: 4,
      //     },
      //   },
      //   {
      //     fieldName: 'fisicaProvincia',
      //     grid: {
      //       xs: 12,
      //       md: 4,
      //     },
      //   },
      //   {
      //     fieldName: 'fisicaCAP',
      //     grid: {
      //       xs: 12,
      //       md: 4,
      //     },
      //   },


      // {
      //   fieldName: 'campo_comune',
      //   grid: {
      //     xs: 12,
      //     md: 4,
      //   },
      // },
      // {
      //   fieldName: 'campo_provincia',
      //   grid: {
      //     xs: 12,
      //     md: 4,
      //   },
      // },
      // {
      //   fieldName: 'campo_cap',
      //   grid: {
      //     xs: 12,
      //     md: 4,
      //   },
      // },

      // {
      //   fieldName: 'campo_input',
      //   grid: {
      //     xs: 12,
      //     md: 12,
      //   },
      // },
      // {
      //   fieldName: 'campo_date',
      //   grid: {
      //     xs: 12,
      //     md: 12,
      //   },
      // },
      // {
      //   fieldName: 'campo_contract',
      //   grid: {
      //     xs: 12,
      //     md: 12,
      //   },
      // },
      // {
      //   fieldName: 'campo_google_address',
      //   grid: {
      //     xs: 12,
      //     md: 12,
      //   },
      // },
      // {
      //   fieldName: 'campo_select',
      //   grid: {
      //     xs: 12,
      //     md: 12,
      //   },
      // },
      {
        fieldName: 'campo_radio',
        grid: {
          xs: 12,
          md: 12,
        },
      },
      {
        fieldName: 'campo_radio2',
        grid: {
          xs: 12,
          md: 12,
        },
      },
    ]
  },
  {
    chapter: false,
    chapterName: 'Form Chapter 2',
    title: 'Secondo step',
    fields: [
      {
        fieldName: fileUpload.name,
        grid: {
          xs: 12,
          md: 6,
        },
      },
      {
        fieldName: idType.name,
        grid: {
          xs: 12,
          md: 6,
        },
      },
    ]
  },
  {
    chapter: true,
    chapterName: 'Form Chapter 2',
    title: 'Secondo step',
    fields: [
      {
        fieldName: 'campo_contract',
        grid: {
          xs: 12,
          md: 12,
        },
      },
      {
        fieldName: 'campo_checkbox',
        grid: {
          xs: 12,
          md: 12,
        },
      },
      {
        fieldName: 'campo_checkbox2',
        grid: {
          xs: 12,
          md: 12,
        },
      },
      {
        fieldName: 'campo_text',
        grid: {
          xs: 12,
          md: 12,
        },
      },
      // {
      //   fieldName: 'campo_stateSelect',
      //   grid: {
      //     xs: 12,
      //     md: 12,
      //   },
      // },
    ],
  },
  // {
  //   chapter: true,
  //   chapterName: 'Form Chapter 3',
  //   title: 'Terzo step',
  //
  //   fields: [
  //     {
  //       fieldName: 'campo_datepicker',
  //       grid: {
  //         xs: 12,
  //         md: 12,
  //       },
  //     },
  //     {
  //       fieldName: 'campo_recaptcha',
  //       grid: {
  //         xs: 12,
  //         md: 12,
  //       },
  //     },
  //   ],
  // },
];

// Contiene dettagli sul case form
const formDetails = {
  title: 'Test case',
  description: 'Descrizione del caso di test',
  stepper: CaseStepperType.Full,
  summary: true,

  helpText: (
    <div>
      <p>Qui spieghiamo a che serve il case.</p>
      <p>Qui spieghiamo a che serve il case.</p>
    </div>
  ),
  successText: (
    <div>
      <p>Il case è stato inviato correttamente. </p>
      <p>Avrai nostre notizie a breve. </p>
    </div>
  )
}


const main = (excludeSteps) => {
  let validation = getValidationSchema();
  if (excludeSteps) {
    const stepsExcluded = excludeSteps;

    let deletedLayout = removeRequiredStep(stepsExcluded, layout)

    const {formField} = model;
    removeDeletedLayoutFields(deletedLayout, formField, initialValues, validation)

    model = {...model, formField}
  }
  return {
    model,
    validationSchema: validation,
    initialValues,
    layout,
    formDetails
  };
}

export default main;
